<div class="bulk-upload-indicator-stack" *ngIf="(jobs$ | async) as jobs" aria-live="polite">
  <ng-container *ngFor="let job of jobs; trackBy: trackByJobId">
    <section class="job-card" role="status"
      [class.job-card--running]="job.status === 'running'"
      [class.job-card--completed]="job.status === 'completed'"
      [class.job-card--failed]="job.status === 'failed'"
      [attr.data-testid]="'bulk-upload-job-' + job.jobId">
      <header class="job-card__header">
        <div class="job-card__icon" aria-hidden="true">
          <span *ngIf="job.status === 'running'" class="spinner"></span>
          <span *ngIf="job.status === 'completed'" class="check">✓</span>
          <span *ngIf="job.status === 'failed'" class="cross">!</span>
        </div>
        <div class="job-card__title-block">
          <div class="job-card__title">
            <ng-container *ngIf="job.status === 'running'">
              {{ 'pages.stock.bulkUpload.backgroundIndicator.title' | translate }}
            </ng-container>
            <ng-container *ngIf="job.status === 'completed'">
              {{ 'pages.stock.bulkUpload.backgroundIndicator.completed' | translate }}
            </ng-container>
            <ng-container *ngIf="job.status === 'failed'">
              {{ 'pages.stock.bulkUpload.backgroundIndicator.failed' | translate }}
            </ng-container>
          </div>
          <div class="job-card__subtitle" *ngIf="job.storeName || job.categoryName">
            {{ 'pages.stock.bulkUpload.backgroundIndicator.subtitle'
              | translate: { storeName: job.storeName, categoryName: job.categoryName } }}
          </div>
        </div>
        <button type="button" class="job-card__dismiss"
          [attr.aria-label]="'pages.stock.bulkUpload.backgroundIndicator.dismiss' | translate"
          [attr.data-testid]="'bulk-upload-job-dismiss-' + job.jobId"
          (click)="onDismiss(job.jobId)">
          ×
        </button>
      </header>

      <div class="job-card__body" *ngIf="job.status === 'running'">
        <div class="progress-bar" role="progressbar"
          [attr.aria-valuenow]="job.percentage"
          aria-valuemin="0"
          aria-valuemax="100">
          <div class="progress-bar__fill"
            [style.width.%]="job.percentage > 0 ? job.percentage : 3"
            [class.progress-bar__fill--indeterminate]="job.percentage === 0">
          </div>
        </div>
        <div class="progress-meta">
          <span class="progress-meta__stage">
            {{ 'pages.stock.bulkUpload.backgroundIndicator.stageLabel' | translate }}: {{ job.stage }}
          </span>
          <span class="progress-meta__counter" *ngIf="job.totalCount > 0">
            {{ job.processedCount }} / {{ job.totalCount }}
          </span>
        </div>
      </div>

      <div class="job-card__error" *ngIf="job.status === 'failed' && job.errorMessage">
        {{ 'pages.stock.bulkUpload.backgroundIndicator.connectionLost' | translate }}
      </div>

      <footer class="job-card__footer" *ngIf="job.status === 'completed'">
        <button type="button" class="job-card__cta"
          [attr.data-testid]="'bulk-upload-job-view-' + job.jobId"
          (click)="onViewResults(job.jobId)">
          {{ 'pages.stock.bulkUpload.backgroundIndicator.viewResults' | translate }}
        </button>
      </footer>
    </section>
  </ng-container>
</div>
